import { CautionIcon } from '@assets/icons/caution';
import { GerarMinutaResponse } from '@libs/types';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

const LimitExceeded = ({ dados }: { dados: GerarMinutaResponse }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const iconSize = isMdUp ? 120 : 88;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setMounted(true), 20);
    return () => clearTimeout(id);
  }, []);

  return (
    <Box
      sx={{
        transition: 'transform 300ms ease, opacity 300ms ease',
        transform: mounted ? 'translateX(0)' : 'translateX(-20px)',
        opacity: mounted ? 1 : 0,
        padding: '16px 0px 0px 0px',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#FF950026',
          mb: '16px',
          border: '1px solid #FF9500',
          borderRadius: '13px',
          padding: { xs: '24px 20px', md: '105px 25px 150px 25px' },
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '24px',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: { xs: 'column', md: 'row' },
            textAlign: { xs: 'center', md: 'left' },
            mb: '32px',
          }}
        >
          <CautionIcon width={iconSize} height={iconSize} />
          <Typography
            sx={{
              color: '#FF9500',
              fontSize: { xs: '20px', md: '24px' },
              fontWeight: 700,
              maxWidth: { md: '20ch' },
            }}
          >
            Sua solicitação excede o limite automático
          </Typography>
        </Box>
        <Typography
          sx={{
            color: '#808080',
            fontSize: '14px',
          }}
        >
          {dados.businessMessage || 'businessMessage'}
        </Typography>
      </Box>
      <Box
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: '#808080',
          mt: { xs: '16px', md: '56px' },
          mb: { xs: '12px', md: '16px' },
        }}
      />
      <Typography
        sx={{
          fontSize: { xs: '12px', md: '14px' },
          color: '#808080',
          textAlign: 'center',
          maxWidth: { xs: '40ch', md: '100%' },
          mx: 'auto',
        }}
      >
        Processamento seguro | Parceria BBMNET + ASAS Garantias
      </Typography>
    </Box>
  );
};

export default LimitExceeded;
